import { applyStepsWithConfig } from '../../e2e/merchant.utils';

export const signup = {
  country: 'GB',
};

const storeDetails = {
  averageOrderValue: 150,
  storeUrl: 'http://test.com',
  paymentDelay: 21,
  paymentInterval: 'DAILY',
  goodsCategory: 'ADULT_SHOES_AND_CLOTHING',
  customerSupportEmail: 'test@test.com',
  registrationCountry: signup.country,
  mainSellingCountry: 'GB',
};

export const prefillInformation = {
  ...storeDetails,
  products: [
    {
      selling_country: 'BE',
      product_name: 'PAY_NOW_BANK_TRANSFER',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'BE',
      product_name: 'PAY_LATER_BY_CARD',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'BE',
      product_name: 'SOFORT_CLASSIC',
      yearly_acquired_volume: 200,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'AT',
      product_name: 'PAY_LATER_IN_14',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'AT',
      product_name: 'KCO_AMEX',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'AT',
      product_name: 'SOFORT_CLASSIC',
      yearly_acquired_volume: 200,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'SE',
      product_name: 'PAY_LATER_IN_30',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'SE',
      product_name: 'KCO_B2B',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'SE',
      product_name: 'SOFORT_CLASSIC',
      yearly_acquired_volume: 200,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'DE',
      product_name: 'PAY_LATER_IN_30',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'DE',
      product_name: 'KCO_B2B',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'DE',
      product_name: 'SOFORT_CLASSIC',
      yearly_acquired_volume: 200,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'NL',
      product_name: 'PAY_LATER_IN_30',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'NL',
      product_name: 'KCO_AMEX',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'NL',
      product_name: 'SOFORT_CLASSIC',
      yearly_acquired_volume: 200,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'FR',
      product_name: 'PAY_LATER_BY_CARD',
      yearly_acquired_volume: 100,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'FR',
      product_name: 'UNBRANDED_CARD_STANDARD',
      yearly_acquired_volume: 200,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'FR',
      product_name: 'SOFORT_CLASSIC',
      yearly_acquired_volume: 200,
      channels: ['ONLINE'],
    },
  ],
};

export const prefillInformationWithFCA = {
  ...storeDetails,
  products: [
    {
      selling_country: 'GB',
      product_name: 'SLICE_IT_CREDIT',
      yearly_acquired_volume: 200,
      channels: ['ONLINE'],
    },
    {
      selling_country: 'GB',
      product_name: 'FINANCING_FLEXIBLE',
      yearly_acquired_volume: 200,
      channels: ['ONLINE'],
    },
  ],
};

export const businessConcepts = ['VOUCHER'];

export const companyDetails = {
  companyName: 'Test Company',
  registrationNumber: '12345678',
  operatingCountry: 'SE',
};

export const companyDetailsUnregistered = {
  companyName: 'Test Company',
  registrationNumber: '',
  operatingCountry: 'GB',
};

export const fcaNumber = {
  fcaNumber: '12345',
};

export const applyStepConfig = {
  signup: {
    value: signup,
    method: 'spreadProperty',
    path: null,
  },
  prefillInformation: {
    value: prefillInformation,
    method: 'spreadProperty',
    path: 'prefillInformation',
  },
  businessConcepts: {
    value: businessConcepts,
    method: 'applyProperty',
    path: 'businessConcepts',
  },
  companyDetails: {
    value: companyDetails,
    method: 'spreadProperty',
    path: null,
  },
  companyDetailsUnregistered: {
    value: companyDetailsUnregistered,
    method: 'spreadProperty',
    path: null,
  },
  fcaNumber: {
    value: fcaNumber,
    method: 'spreadProperty',
    path: null,
  },
};

export const getPreAssessmentWithSteps = applyStepsWithConfig(applyStepConfig);
